import React, { ChangeEvent, useEffect, useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import "./CadastroProduto.css";
import { useNavigate, useParams } from "react-router-dom";
import Categoria from "../../../models/Categoria";
import Produto from "../../../models/Produto";
import { busca, buscaId, post, put } from "../../../services/Service";
import { useSelector } from "react-redux";
import { TokenState } from "../../../store/tokens/tokensReducer";
import { toast } from "react-toastify";
import ListaProduto from "../listaProduto/ListaProduto";

function CadastroProduto() {
  let navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [categorias, setCategorias] = useState<Categoria[]>([]);
  const token = useSelector<TokenState, TokenState["tokens"]>(
    (state) => state.tokens
  );

  useEffect(() => {
    if (token == "") {
      toast.error("Você precisa estar logado", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "colored",
        progress: undefined,
      });
      navigate("/login");
    }
  }, [token]);

  const [categoria, setCategoria] = useState<Categoria>({
    id: 0,
    secao: "",
    descricao: "",
  });
  const [produto, setProduto] = useState<Produto>({
    id: 0,
    nome: "",
    preco: 0,
    estoque: 0,
    descricao: "",
    foto: "",
    desconto: "",
    categoria: null,
  });

  useEffect(() => {
    setProduto({
      ...produto,
      categoria: categoria,
    });
  }, [categoria]);

  useEffect(() => {
    getCategoria();
    if (id !== undefined) {
      findByIdProduto(id);
    }
  }, [id]);

  async function getCategoria() {
    await busca("/categoria", setCategorias, {
      headers: {
        Authorization: token,
      },
    });
  }

  async function findByIdProduto(id: string) {
    await buscaId(`produto/${id}`, setProduto, {
      headers: {
        Authorization: token,
      },
    });
  }

  function updatedProduto(e: ChangeEvent<HTMLInputElement>) {
    setProduto({
      ...produto,
      [e.target.name]: e.target.value,
      categoria: categoria,
    });
  }

  async function onSubmit(e: ChangeEvent<HTMLFormElement>) {
    e.preventDefault();

    if (id !== undefined) {
      put(`/produto`, produto, setProduto, {
        headers: {
          Authorization: token,
        },
      });
      toast.success("Produto atualizado com sucesso", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "colored",
        progress: undefined,
      });
    } else {
      post(`/produto`, produto, setProduto, {
        headers: {
          Authorization: token,
        },
      });
      toast.success("Produto cadastrado com sucesso", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "colored",
        progress: undefined,
      });
    }
    back();
  }

  function back() {
    navigate("/produto");
  }

  return (
    <Container maxWidth="sm" className="topo">
      <form onSubmit={onSubmit}>
        <Typography
          variant="h3"
          color="textSecondary"
          component="h1"
          align="center"
        >
          Formulário de Cadastro Produtos
        </Typography>
        <TextField
          value={produto.nome}
          onChange={(e: ChangeEvent<HTMLInputElement>) => updatedProduto(e)}
          id="nome"
          label="Nome"
          variant="outlined"
          name="nome"
          margin="normal"
          fullWidth
        />
        <TextField
          value={produto.preco}
          onChange={(e: ChangeEvent<HTMLInputElement>) => updatedProduto(e)}
          id="preco"
          label="Preço"
          name="preco"
          variant="outlined"
          margin="normal"
          fullWidth
        />
        <TextField
          value={produto.estoque}
          onChange={(e: ChangeEvent<HTMLInputElement>) => updatedProduto(e)}
          id="estoque"
          label="Estoque"
          name="estoque"
          variant="outlined"
          margin="normal"
          fullWidth
        />
        <TextField
          value={produto.descricao}
          onChange={(e: ChangeEvent<HTMLInputElement>) => updatedProduto(e)}
          id="descricao"
          label="Descrição"
          name="descricao"
          variant="outlined"
          margin="normal"
          fullWidth
        />
        <TextField
          value={produto.foto}
          onChange={(e: ChangeEvent<HTMLInputElement>) => updatedProduto(e)}
          id="foto"
          label="Foto"
          name="foto"
          variant="outlined"
          margin="normal"
          fullWidth
        />
        <TextField
          value={produto.desconto}
          onChange={(e: ChangeEvent<HTMLInputElement>) => updatedProduto(e)}
          id="desconto"
          label="Desconto"
          name="desconto"
          variant="outlined"
          margin="normal"
          fullWidth
        />
        <FormControl>
          <InputLabel id="demo-simple-select-helper-label">
            Categoria{" "}
          </InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            onChange={(e) =>
              buscaId(`/categoria/${e.target.value}`, setCategoria, {
                headers: {
                  Authorization: token,
                },
              })
            }
          >
            {categorias.map((categoria) => (
              <MenuItem value={categoria.id}>{categoria.secao}</MenuItem>
            ))}
          </Select>
          <FormHelperText>Escolha uma categoria para o produto</FormHelperText>
          <Button type="submit" variant="contained" color="primary">
            Finalizar
          </Button>
        </FormControl>
      </form>
    </Container>
  );
}
export default CadastroProduto;